interface LoadingSpinnerProps {
  message?: string;
}

export function LoadingSpinner({ message }: LoadingSpinnerProps) {
  return (
    <div className="loading-spinner-container">
      <div className="loading-spinner-icon">
        <img
          src="/assets/fakto-icon.svg"
          alt="Loading"
          className="spinner-image"
        />
      </div>
      {message && <p className="loading-spinner-message">{message}</p>}
    </div>
  );
}
